import React from "react";
import { DollarSign, CheckCircle2, Circle, ChevronRight } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { shortAddress } from "@/lib/address";

export default function OpenHouseRow({ oh, mode, selected, onToggle, onToggleVisited, onOpenDetail }) {
  const ev = oh._displayEvent;
  const startTime = ev?.start_at ? new Date(ev.start_at) : null;
  const endTime = ev?.end_at ? new Date(ev.end_at) : null;
  const timeStr = startTime
    ? startTime.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })
    : "—";
  const endStr = endTime
    ? endTime.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })
    : "";
  return (
    <li
      className={`flex items-start gap-3 px-3 sm:px-4 py-3 hover:bg-slate-50 transition ${
        oh.visited ? "opacity-60" : ""
      }`}
      data-testid={`oh-row-${oh.id}`}
    >
      <div className="pt-1">
        <Checkbox
          checked={selected}
          onCheckedChange={onToggle}
          className="min-h-[20px] min-w-[20px]"
          aria-label={`Select ${oh.address_raw}`}
          data-testid={`oh-checkbox-${oh.id}`}
        />
      </div>
      <div className="flex-1 min-w-0 cursor-pointer" onClick={onOpenDetail}>
        <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
          {mode === "agenda" ? (
            <>
              <span className="text-sm font-semibold text-slate-900 tabular-nums">{timeStr}</span>
              {endStr ? (
                <span className="text-xs text-slate-500 tabular-nums">→ {endStr}</span>
              ) : null}
            </>
          ) : null}
          {oh.price_display ? (
            <span className="inline-flex items-center text-xs font-medium text-emerald-700">
              <DollarSign className="h-3 w-3" /> {oh.price_display}
            </span>
          ) : null}
          {oh.bedrooms ? <span className="text-xs text-slate-500">{oh.bedrooms} bd</span> : null}
          {oh.bathrooms ? <span className="text-xs text-slate-500">{oh.bathrooms} ba</span> : null}
          {oh.sqft ? <span className="text-xs text-slate-500">{oh.sqft}</span> : null}
        </div>
        <div className="text-sm text-slate-900 mt-0.5 truncate" title={oh.address_raw}>
          {shortAddress(oh.address_raw) || "—"}
        </div>
        <div className="text-xs text-slate-500 mt-0.5 truncate">
          {oh.neighborhood && mode === "agenda" ? <span>{oh.neighborhood} · </span> : null}
          {oh.realtor_name ? <span>{oh.realtor_name}</span> : <span className="italic">Unassigned</span>}
          {oh.brokerage_name ? <span className="text-slate-400"> · {oh.brokerage_name}</span> : null}
        </div>
      </div>
      <div className="flex flex-col items-end gap-1 shrink-0">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onToggleVisited();
          }}
          className={`inline-flex items-center gap-1 px-2 py-1 rounded text-xs font-medium border min-h-[36px] ${
            oh.visited
              ? "bg-emerald-50 text-emerald-700 border-emerald-200"
              : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50"
          }`}
          data-testid={`toggle-visited-${oh.id}`}
        >
          {oh.visited ? (
            <>
              <CheckCircle2 className="h-3 w-3" /> Visited
            </>
          ) : (
            <>
              <Circle className="h-3 w-3" /> Mark visited
            </>
          )}
        </button>
        <ChevronRight className="h-4 w-4 text-slate-300" />
      </div>
    </li>
  );
}
